import { createSlice } from '@reduxjs/toolkit';

// 상태 타입 정의
interface PreloaderState {
  isOpen: boolean;
}

const initialState: PreloaderState = {
  isOpen: false
};

const preloaderSlice = createSlice({
  name: 'preloader',
  initialState,
  reducers: {
    // 다이얼로그를 여는 액션 (type, title, message를 받음)
    showPreloader: (state) => {
      state.isOpen = true;
    },
    // 다이얼로그를 닫는 액션
    hidePreloader: (state) => {
      state.isOpen = false;
    },
  },
});

export const { showPreloader, hidePreloader } = preloaderSlice.actions;
export default preloaderSlice.reducer;